// @flow

import actionCreators from "@modules/reporting/actionCreator";
import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import { GetManagerCompliance } from "@modules/reporting/constants/actions";
import http from "@http";
import { formatDateToInputFormat } from "@transformers/date";

type ManagerRequest = $Exact<{
  clientId: number,
  employeeId: number,
}>;

type ManagerComplianceRequest = $Exact<{
  ...ManagerRequest,
  filters?: $Exact<{
    fromDate: string,
    toDate: string,
  }>,
}>;

export function* onGetManagerCompliance({
  payload,
}: Action<ManagerComplianceRequest>): Generator<*, void, *> {
  if (!payload || !payload.clientId || !payload.employeeId) {
    throw Error("Invalid payload provided");
  }

  const filters = payload.filters || {
    fromDate: formatDateToInputFormat(new Date()),
    toDate: formatDateToInputFormat(new Date()),
  };

  try {
    const response = yield call(
      http.post,
      `/api/v1/reports/client/${payload.clientId}/employee/${payload.employeeId}/reports/manager-compliance`,
      filters,
    );

    yield put(actionCreators.GetManagerComplianceSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.GetManagerComplianceError(e.response));
  }
}

export function* ManagerComplianceSaga(): Generator<*, void, void> {
  yield all([takeEvery(GetManagerCompliance, onGetManagerCompliance)]);
}

export default ManagerComplianceSaga;
